import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(MUITheme => ({
  termsConditionsContainer:{
    minHeight: "calc(100vh - 64px - 24px)",
    paddingTop: 38,
    flexDirection: 'column',
    background: MUITheme.palette.background.primary,
    '@media(max-width:820px)':{ height: 'auto' }
  },
  termsBox:{
    width: 'calc(100% - 140px)',
    padding: '24px',
    margin: '0 auto',
    borderRadius: 4,
    backgroundColor: MUITheme.palette.background.white,
    boxShadow: '8px 16px 48px 0 rgba(0,0,0,0.1)',
    [MUITheme.breakpoints.down("sm")]: { width: 'calc(100% - 60px)' },
    [MUITheme.breakpoints.down("xs")]: { width: 'calc(100% - 40px)' },
    '& .lu-inner':{
      display:'none'
    },
    "&.user-profile":{
      width: 'calc(100% - 12px)',
      '& .lu-inner':{
        display:'block'
      },
      '& .lu-outer':{
        display:'none'
      }
    }
  },
  termsConditionsHeaders:{
    display: 'flex',
    justifyContent: 'space-between',
    [MUITheme.breakpoints.down("sm")]: { flexDirection: 'column' },
  },
  headerDescription:{
    '& h4': {
      fontFamily: 'Nunito Sans',
      fontSize: 19,
      fontWeight: 600,
    },
    '& p':{
      color: MUITheme.palette.text.inputLabel,
      fontFamily: MUITheme.typography.fontFamily.secondary,
      fontSize: 12,
      fontStyle: 'italic',
      lineHeight: '21px',
      maxWidth: '710px'
    }
  },
  lastUpdateContainer:{
    '& p':{
      color: '#1A237E',
      fontFamily: 'Nunito Sans',
      fontSize: 13,
      fontWeight: 600,
    },
    [MUITheme.breakpoints.down("sm")]: { 
      display: 'flex',
      justifyContent: 'flex-end'
    },
  },
  termstermsConditionsContent:{
    boxSizing: 'border-box',
    borderRadius: 3,
    marginTop: 15,
    color: MUITheme.palette.text.primary,
    fontSize: 14,
    lineHeight: '19px',
    overflow: 'auto',
    '& div':{ paddingBottom: 10 },
    '& p':{ marginTop: 0 },
    '& span':{ fontWeight: 'bold' },
    '& ul li':{ listStyle: 'none' },
    '& h1':{ 
      paddingBottom: 20,
      borderBottom: '1px solid #4f81bd',
      marginTop: 0,
      color: '#17365d',
      fontSize: 26,
      fontWeight: 500
    },
    '& h2':{
      marginBottom: 3,
      fontSize: 15,
      fontWeight: 500,
      color: '#4f81bd'
    }
  },
  footerText:{
    padding: '24px 0',
    background: MUITheme.palette.background.primary,
    textAlign: 'center',
    '@media(max-width:820px)':{ padding: 30 }
  }
}));
